import { createSlice, CaseReducer, createAsyncThunk } from '@reduxjs/toolkit';

import { get, post } from 'api/requests';

import { IParamsReq } from 'types';
import { CallEngAllocated } from 'pages/Calls/EngineeringCalls/types';

const initialState: CallsStore = {
  count: 0,
  currentRequestId: undefined,
  list: [],
  loading: false,
  noData: false,
};

const reset: CaseReducer<CallsStore> = () => initialState;

export const allocatedSlice = createSlice({
  name: 'calls_engineeringNetworks_allocated',
  initialState,
  reducers: {
    reset,
  },
  extraReducers: builder => {
    builder
      .addCase(getEngineeringAllocatedCalls.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(getEngineeringAllocatedCalls.fulfilled, (state, { payload }) => {
        state.loading = false;

        if (payload) {
          const { results, count } = payload;
          state.list = results;
          state.count = count;
          state.noData = results.length === 0;
        }
      })
      .addCase(getEngineeringAllocatedCalls.rejected, (state, action) => {
        const { requestId } = action.meta;

        if (state.loading === true && state.currentRequestId === requestId) {
          state.loading = false;
        }
      });
  },
});

export const { reset: setReset } = allocatedSlice.actions;

export const getEngineeringAllocatedCalls = createAsyncThunk(
  'get_EngineeringAllocated',
  async (params: IParamsReq, thinkApi) => {
    try {
      const { data } = await get<Responce>(
        '/api/standards/engineering_networks/on_inspection_view/',
        params,
      );
      return data;
    } catch (error) {
      return thinkApi.rejectWithValue(error);
    }
  },
);

export const sendAllocatedExcel = (reqData: IParamsReq): void => {
  post('/api/standards/engineering_networks/on_inspection_view/excel/', reqData);
};

interface CallsStore {
  count: number;
  currentRequestId: string | undefined;
  list: CallEngAllocated[];
  loading: boolean;
  noData: boolean;
}

type Responce = {
  count: number;
  next: string | null;
  previous: string | null;
  results: CallEngAllocated[];
};
